const HOTELS_SENTENCES = [
    "Hotels.postbookLoader.confirmingRoom",
    "Hotels.postbookLoader.securingRate",
    "Hotels.postbookLoader.processingDetails",
    "Hotels.postbookLoader.checkingAvailability",
    "Hotels.postbookLoader.reservingRoom",
    "Hotels.postbookLoader.verifyingGuests",
    "Hotels.postbookLoader.finalizingStay",
    "Hotels.postbookLoader.issuingConfirmation",
    "Hotels.postbookLoader.holdingRoom",
    "Hotels.postbookLoader.syncingDates",
    "Hotels.postbookLoader.confirmingRoomType",
    "Hotels.postbookLoader.notifyingHotel",
    "Hotels.postbookLoader.generatingReference",
    "Hotels.postbookLoader.preparingWelcome",
    "Hotels.postbookLoader.almostThere",
]

export {HOTELS_SENTENCES};
